import { render, staticRenderFns } from "./Readme.vue?vue&type=template&id=19895e08&scoped=true"
import script from "./Readme.vue?vue&type=script&lang=js"
export * from "./Readme.vue?vue&type=script&lang=js"
import style0 from "./Readme.vue?vue&type=style&index=0&id=19895e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19895e08",
  null
  
)

export default component.exports